/**
 * Public SDK entry — bundled into dist/p2p-hls.{esm,iife}.js.
 *
 * IIFE global: `window.P2PHls.createP2PPlayer(video, config)`.
 * ESM:         `import { createP2PPlayer } from "@p2p-hls/web-player"`.
 */
export { createP2PPlayer, fetchP2PConfig } from "./player.js";
export type { P2PPlayer, P2PPlayerConfig, PlayerMode, PlayerStatus, P2PRuntimeConfig } from "./player.js";
export type { DrmConfig } from "./drm.js";
export { webrtcSupported } from "@p2p-hls/core-engine";
export type { MetricsSnapshot } from "@p2p-hls/core-engine";
